module.exports = __webpack_public_path__ + "img/map.413fd5b3.png";